import { useQuery } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import { useAuthStore } from "../../store/authStore"
import { getAllIssues } from "../../api/issuesApi"
import { useEffect } from "react"
import { XOctagon } from "react-feather"

const Issues = () => {
    const navigate = useNavigate()
    const { token, setLoaderState } = useAuthStore((state) => state)

    const { isLoading, data } = useQuery({
        queryFn: getAllIssues,
        queryKey: [token],
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading])
    return (
        <>
            <div className="p-4">
                <ToastContainer />
                <div className="flex justify-between items-center">
                    <h1 className="text-4xl w-full h-full">All Issues</h1>
                    <div className="flex">
                        <button
                            onClick={() => navigate("/layout/report-issue")}
                            className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                        >
                            Report an issue
                        </button>
                    </div>
                </div>
                <br />
                <hr />
                <div>
                    {data?.data?.data?.length === 0 ? (
                        <div className="flex w-full justify-center">
                            <span className="text-slate-400 text-xl">No Issues added</span>
                        </div>
                    ) : (
                        data?.data?.data?.map((issue, index) => (
                            <div key={index} className="drone-card cursor-pointer bg-white p-4 border rounded-xl my-4"
                                onClick={() => { navigate(`/layout/issue-details/${issue._id}`) }}
                            >
                                <div className="flex">
                                    <XOctagon size={32} className="text-tblu" />
                                    <div className="grid grid-cols-3 gap-20 ml-8"><div> Issue:-{issue?.issue}</div> <div> DroneName :- {issue?.droneId?.droneName}</div> <div>Date :-{new Date(issue?.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</div></div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </>
    )
}

export default Issues